import {ROUTES} from '../../../config/index.js'

export const getInitialProps = async ({routeInfo, context: {i18n, domain}}) => {
  const {
    location: {pathname: path},
    params: {make: makeUrlParam}
  } = routeInfo

  const config = domain.get('config')
  const {TECHNICAL_DETAILS_PATH_PATTERN} = config.get('page')
  const {
    ERRORS: {GetModelsGroupedByBodyTypeDoorsVehiclesError}
  } = config.get('COMMON')

  const {culture} = i18n

  const serverErrors = []

  const initialTechnicalDetailsMakeFactory = async () => {
    const getModels = async () => {
      try {
        return await domain.get('get_models_grouped_by_body_type_doors_vehicles_use_case').execute({makeUrlParam})
      } catch (error) {
        serverErrors.push(error)
      }
    }

    const getMakes = async () => {
      try {
        return await domain
          .get('get_marketed_makes_vehicles_use_case')
          .execute({urlPrefix: TECHNICAL_DETAILS_PATH_PATTERN})
      } catch (error) {
        serverErrors.push(error)
      }
    }

    const modelsResponse = await getModels()

    const makesResponse = await getMakes()

    const {pageName} = await domain.get('get_page_name_page_use_case').execute({path})

    const normalizeUrlParamName = ({makeUrlParam}) =>
      makeUrlParam
        .split('_')
        .map(item => item.toUpperCase())
        .join(' ')

    const makeName = normalizeUrlParamName({makeUrlParam})

    // Get make associated to makeUrlParam from makesList
    const make = makesResponse?.makesList.find(
      ({name}) => name.toUpperCase() === makeUrlParam.replace('_', ' ').toUpperCase()
    )

    const filteredMakesList = makesResponse?.makesList.filter(
      ({name}) => name.toUpperCase() !== makeUrlParam.replace('_', ' ').toUpperCase()
    )

    const [[seoDataError, seoDataResponse], tagclouds, [, breadcrumbs]] = await Promise.all([
      domain.get('get_seo_data_use_case').execute({
        culture,
        pageName,
        params: {make: makeUrlParam}
      }),
      domain.get('get_tagcloud_seo_use_case').execute({pageName, makeId: make?.id}),
      domain.get('get_breadcrumbs_breadcrumb_use_case').execute({pageName, params: {section: makeName}})
    ])

    const seoData = seoDataResponse || {}

    const hasCriticalServerErrors = serverErrors.some(
      serverError => serverError instanceof GetModelsGroupedByBodyTypeDoorsVehiclesError
    )

    return {
      ...(hasCriticalServerErrors && {__HTTP__: {redirectTo: ROUTES.TECHNICAL_DETAILS.INDEX}}),
      breadcrumbs,
      helmet: seoData.head,
      makeId: make?.id,
      makeName,
      makeUrlParam,
      pageName,
      serverErrors,
      pageErrors: {
        seoDataError
      },
      tagclouds,
      ...(filteredMakesList && {filteredMakesList}),
      /**
       * @param {Object} modelsResponse
       * @param {Object} modelsResponse.models
       * */
      ...(modelsResponse && {...modelsResponse})
    }
  }

  const initialTechnicalDetailsMake = await initialTechnicalDetailsMakeFactory()

  return initialTechnicalDetailsMake
}
